import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useContext } from 'react';
import { vlpBannerIcons } from "../Price/PriceBannersIcons";
import { Flex, Text } from '@chakra-ui/react';
import { SizeContext } from "../../../atoms/contexts/SizeContext";
import { getSizedPraxisStyles } from "./CardVlp.styles";
export var PraxisVlp = function PraxisVlp(_ref) {
  var _ref$text = _ref.text,
    text = _ref$text === void 0 ? 'Vaste lage prijs' : _ref$text;
  var _useContext = useContext(SizeContext),
    _useContext$sizes = _useContext.sizes,
    sizes = _useContext$sizes === void 0 ? ['sm', 'lg'] : _useContext$sizes;
  if (!sizes || !sizes.length) return null;
  return /*#__PURE__*/React.createElement(Flex, {
    bg: "white",
    alignItems: "center",
    color: "red.primary",
    fontFamily: "bold",
    fontSize: "2xs",
    gap: "0.5em",
    sx: _objectSpread({}, getSizedPraxisStyles(sizes)),
    "data-testid": "molecules-CardVlp-Flex"
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      height: '1.8em',
      width: '1.8em'
    },
    src: vlpBannerIcons['18x18'],
    alt: "",
    "data-testid": "molecules-CardVlp-img"
  }), /*#__PURE__*/React.createElement(Text, {
    textAlign: "center"
  }, text));
};